module.exports = __webpack_public_path__ + "img/kibbles-TGR.d83af6d.png";